import Link from 'next/link'

import { clsx } from 'clsx'

import { FC } from 'react'

import { IClassName } from '@/app/shared/interfaces/common.interface'
import useLayout from '@/app/shared/store/layout.store'

// interface
interface IPhoneInfo extends IClassName {
  className?: string
}

// component
const PhoneInfoComponent: FC<Readonly<IPhoneInfo>> = ({ className }) => {
  const phones = useLayout((state) => state.phones)
  const schedule = useLayout((state) => state.schedule)

  // return
  return (
    <div
      className={clsx(
        'flex items-center justify-between gap-2.5 border-b-primary text-primary max-tablet:mb-2 max-tablet:border-b-1 max-tablet:pb-2 tablet:gap-8',
        className,
      )}
    >
      <ul className={'flex items-center gap-2.5 text-[13px] tablet:gap-8 tablet:text-[22px]'}>
        {phones.map((item, index: number) => (
          <li key={index}>
            <Link
              href={`tel:${item?.value?.replace(/\D/g, '')}`}
              className={'font-semibold outline-0 transition'}
            >
              {item?.value}
            </Link>
          </li>
        ))}
      </ul>
      <div className={'flex h-auto flex-col text-[10px] font-semibold tablet:text-[14px]'}>
        <ul className={'mt-auto grid'}>
          {schedule.map((item, index: number) => (
            <li key={`${item?.key}_${index}`}>{item?.value}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default PhoneInfoComponent
